// Firebase Configuration and Analytics Setup for ThinqBits
// Client-side Firebase initialization with Analytics

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId, setUserProperties } from "firebase/analytics";

// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: "AIzaSyDDMPrcTL2c0xc9pnRofOMxGzP0NnERQYg",
    authDomain: "thinqbits.firebaseapp.com",
    databaseURL: "https://thinqbits-default-rtdb.firebaseio.com",
    projectId: "thinqbits",
    storageBucket: "thinqbits.firebasestorage.app",
    messagingSenderId: "164009890689",
    appId: "1:164009890689:web:598d1350d2dcb384414e80",
    measurementId: "G-Y7W8M9GH8W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
    console.log('✅ Firebase Analytics initialized');
  } catch (error) {
    console.warn('⚠️ Firebase Analytics initialization failed:', error);
  }
}

// Analytics Helper Functions
export const Analytics = {
  // Track custom events
  trackEvent: (eventName, eventParams = {}) => {
    if (analytics) {
      logEvent(analytics, eventName, eventParams);
    }
  },

  // Track page views
  trackPageView: (pageName, additionalParams = {}) => {
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_title: pageName,
        page_location: window.location.href,
        page_path: window.location.pathname,
        ...additionalParams
      });
    }
  },

  // Track user actions
  trackUserAction: (action, category, label = '', value = null) => {
    if (analytics) {
      const params = {
        event_category: category,
        event_label: label
      };
      if (value !== null) {
        params.value = value;
      }
      logEvent(analytics, action, params);
    }
  },

  // Set user ID
  setUser: (userId) => {
    if (analytics) {
      setUserId(analytics, userId);
    }
  },

  // Set user properties
  setUserProps: (properties) => {
    if (analytics) {
      setUserProperties(analytics, properties);
    }
  },

  // Track session events
  trackSessionCreated: (sessionId, framework, thinqersCount) => {
    if (analytics) {
      logEvent(analytics, 'session_created', {
        session_id: sessionId,
        framework: framework,
        thinqers_count: thinqersCount,
        timestamp: new Date().toISOString()
      });
    }
  },

  trackSessionStarted: (sessionId, framework) => {
    if (analytics) {
      logEvent(analytics, 'session_started', {
        session_id: sessionId,
        framework: framework,
        timestamp: new Date().toISOString()
      });
    }
  },

  trackSessionCompleted: (sessionId, totalTurns, duration) => {
    if (analytics) {
      logEvent(analytics, 'session_completed', {
        session_id: sessionId,
        total_turns: totalTurns,
        duration_seconds: duration,
        timestamp: new Date().toISOString()
      });
    }
  },

  // Track thinqer interactions
  trackThinqerSelected: (thinqerId, thinqerName, stance) => {
    if (analytics) {
      logEvent(analytics, 'thinqer_selected', {
        thinqer_id: thinqerId,
        thinqer_name: thinqerName,
        stance: stance
      });
    }
  },

  // Track turn events
  trackTurnCompleted: (sessionId, turnNumber, speaker) => {
    if (analytics) {
      logEvent(analytics, 'turn_completed', {
        session_id: sessionId,
        turn_number: turnNumber,
        speaker: speaker
      });
    }
  },

  // Track report generation
  trackReportGenerated: (sessionId, reportType) => {
    if (analytics) {
      logEvent(analytics, 'report_generated', {
        session_id: sessionId,
        report_type: reportType,
        timestamp: new Date().toISOString()
      });
    }
  },

  // Track framework selection
  trackFrameworkSelected: (framework) => {
    if (analytics) {
      logEvent(analytics, 'framework_selected', {
        framework: framework
      });
    }
  },

  // Track authentication events
  trackSignIn: (method) => {
    if (analytics) {
      logEvent(analytics, 'login', {
        method: method
      });
    }
  },

  trackSignUp: (method) => {
    if (analytics) {
      logEvent(analytics, 'sign_up', {
        method: method
      });
    }
  },

  // Track errors
  trackError: (errorMessage, errorContext = '') => {
    if (analytics) {
      logEvent(analytics, 'error', {
        error_message: errorMessage,
        error_context: errorContext,
        timestamp: new Date().toISOString()
      });
    }
  },

  // Track file uploads
  trackFileUpload: (fileType, fileSize) => {
    if (analytics) {
      logEvent(analytics, 'file_upload', {
        file_type: fileType,
        file_size: fileSize
      });
    }
  }
};

// Export the initialized app and analytics
export { app, analytics };
export default Analytics;
